import { useState, forwardRef, useEffect } from "react";
import {
  IconButton,
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Slide,
  TextField,
  Grid,
  Typography,
  Paper,
} from "@mui/material";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";

import { deleteMeeting } from "../../api/meetings.js";
import { role } from "../../config/roles.js";
import { usersTable } from "../../config/grid-column-defs.js";
import useSnackbar from "../../hooks/useSnackbar.js";
import {
  activateUserById,
  deactivateUserById,
  deleteUserById,
  getUsers,
} from "../../api/user.js";
import { DeleteForever } from "@mui/icons-material";
import useErrorHandler from "../../hooks/useErrorHandler.js";

export default function Users() {
  const { data: user } = useSelector((state) => state.user);
  const [filterFirstname, setFirstnameFilter] = useState("");
  const [filterRole, setRoleFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [deletingUserId, setDeletingUserId] = useState("");
  const [activeDeactive, setActiveDeactive] = useState("");
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const [usersTableRefreshCount, setUsersTableRefreshCount] = useState(0);
  function refreshUsersTable() {
    setUsersTableRefreshCount((prev) => prev + 1);
  }

  const dialogAction = useSelector((state) => state.dialog);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "ACTIVEINACTIVE":
        dispatch({ type: "" });
        handleActivateDeactivate(dialogAction.data);

        break;
      case "DELETE":
        dispatch({ type: "" });
        setDeletingUserId(dialogAction.data.id);

        break;

      default:
        break;
    }
  }, [dialogAction]);
  const getToken = async () => user.token;

  const handleActivateDeactivate = async (newdata) => {
    let data = {};
    try {
      if (newdata.account_status === "ACTIVE") {
        data = await deactivateUserById(newdata.id, user.token);
      } else {
        data = await activateUserById(newdata.id, user.token);
      }
      refreshUsersTable();
      snackbar.showSuccess(data.data.msg);
    } catch (error) {
      errorHandler(error);
    }
  };
  // function onUserTableCellClicked({ colDef, data }) {
  //   if (colDef.field === "action") {
  //     console.log("user===", data);
  //     setDeletingUserId(data.id);
  //     setActiveDeactive(data.account_status);
  //   }
  // }

  async function getUserTableData(limit, offset) {
    try {
      const { data } = await getUsers(user.token, {
        limit,
        offset,
        firstname: filterFirstname,
        role: filterRole,
      });
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (usersTable.some((m) => m.field === "action")) return;
    usersTable.unshift({
      field: "action",
      headerName: "Action",
      value: "DEL",
      minWidth: 140,
      headerClass: "text-center",
      cellRendererFramework: (params) => (
        <Box>
          <Grid container>
            <Grid item xs={10} sm={10} md={10} lg={10} textAlign="center">
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  dispatch({ type: "ACTIVEINACTIVE", data: params.data });
                }}
                className="act-dec-blue-button"
              >
                {params.data && params.data.account_status === "ACTIVE"
                  ? "Deactivate"
                  : "Activate"}
                {/* {params.data && params.data.account_status} */}
              </Button>
            </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <IconButton
                size="small"
                variant="contained"
                color="error"
                onClick={() => {
                  dispatch({ type: "DELETE", data: params.data });
                }}
              >
                <DeleteForever />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      ),
    });
  }, [usersTable]);

  const onDeleteComplete = () => {
    refreshUsersTable();
    setDeletingUserId("");
  };
  useEffect(() => {
    refreshUsersTable();
  }, [filterFirstname, filterRole]);

  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Grid
            container
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            className="!flex justify-between items-center"
          >
            <Grid item xs={12} sm={3} md={4} lg={5}>
              <Typography className="heading-title">Users</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={5} lg={5}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              >
                <Grid item xs={6} sm={6} md={6}>
                  <TextField
                    size="small"
                    // className={classes.textfeild}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="First name"
                    value={filterFirstname}
                    onChange={(e) => {
                      setFirstnameFilter(e.target.value);
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <TextField
                    size="small"
                    // className={classes.textfeild}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Role"
                    value={filterRole}
                    onChange={(e) => {
                      setRoleFilter(e.target.value);
                    }}
                    fullWidth
                    select
                  >
                    <MenuItem value="">All roles</MenuItem>
                    {role.map((r) => (
                      <MenuItem key={r.Type} value={r.Type} className="!capitalize">
                        {r.Type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3} md={3} lg={2}>
              <Link to="new">
                <Button
                  // sx={{ ml: 2, }}
                  variant="contained"
                  size="large"
                  color="primary"
                  className="blue-button"
                  fullWidth
                >
                  Create User
                </Button>
              </Link>
            </Grid>
          </Grid>
          {loading ? <CircularProgress /> : <></>}
        </Box>
        <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getUserTableData}
            // onCellClicked={onUserTableCellClicked}
            columns={usersTable}
            perPage={10}
            refreshCounter={usersTableRefreshCount}
          />
        </div>
        <DeleteUserDialog
          activeDeactive={activeDeactive}
          deletingUserId={deletingUserId}
          setOpen={setDeletingUserId}
          onDeleteComplete={onDeleteComplete}
          token={user.token}
        />
      </Paper>
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteUserDialog({
  activeDeactive,
  setOpen,
  deletingUserId,
  onDeleteComplete,
  token,
}) {
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const handleClose = () => {
    setOpen("");
  };

  const handleDelete = async () => {
    try {
      await deleteUserById(deletingUserId, token);
      snackbar.showSuccess("User Deleted.");
      onDeleteComplete();
    } catch (error) {
      errorHandler(error);
      setOpen("");
    }
  };

  return (
    <Dialog
      open={Boolean(deletingUserId)}
      TransitionComponent={Transition}
      keepMounted
     // onClose={handleClose}
     onClose={() => {       
    }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className="heading-title">Delete User</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          The user will be deleted forever.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          variant="outlined"
          className="black-border-button"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          size="large"
          variant="text"
          color="error"
          className="red-boder-button"
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
